import { React } from 'Imports';
import { SplitClient } from '@splitsoftware/splitio-react';
import { getSplitConfig, TypedSplitFactory } from '$Utilities/split-io-sdk';
import { ConfigService } from '$State/ConfigFreezerService';

interface SplitIOWrapperProps {
    children: React.ReactNode;
}

const SplitIOWrapper = (props: SplitIOWrapperProps) => {
    const splitConfig = getSplitConfig();
    return (
        <TypedSplitFactory
            config={splitConfig}
            updateOnSdkReady={true}
            updateOnSdkReadyFromCache={true}
            updateOnSdkTimedout={true}
            updateOnSdkUpdate={false}
        >
            <SplitClient
                splitKey={ConfigService.getSplitClientKey()}
                updateOnSdkReady={true}
                updateOnSdkReadyFromCache={true}
                updateOnSdkTimedout={true}
                updateOnSdkUpdate={false}
            >
                <>{props.children}</>
            </SplitClient>
        </TypedSplitFactory>
    );
};

export default SplitIOWrapper;
